import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper'
import DropDownListViewModelType from '@/ViewModels/Controls/DropDownListViewModel';
import DropDownListType from '@/Controls/DropDownList';

export default class DropDownListColumnFactory extends ColumnFactory {

    private DropDownListViewModel = ComponentManager.getViewModel<typeof DropDownListViewModelType>('DropDownListViewModel');
    private DropDownList = ComponentManager.getControl<typeof DropDownListType>('DropDownList');
    public static isPlainText = false;
    public static isJQueryElement = true;

    private control: DropDownListType;
    private jQueryControl: JQuery<HTMLElement>;
    private viewModel: DropDownListViewModelType;
    public isEnabled: boolean;
    public data: any;
    public dataTextField: string;
    public dataValueField: string;

    constructor(private params: any) {
        super(params);

        this.isEnabled = this.paramOrDefault(params.isEnabled, true);
        this.data = this.paramOrDefault(params.data, []);
        this.dataTextField = this.paramOrDefault(params.dataTextField, null);
        this.dataValueField = this.paramOrDefault(params.dataValueField, null);
    }

    public getValue(): any {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.DropDownListViewModel({
            factory: this,
            isEnabled: this.isEnabled,
            data: this.data,
            value: this.raw,
            dataTextField: this.dataTextField,
            dataValueField: this.dataValueField
        });

        this.control = new this.DropDownList(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('DropDownListColumn', DropDownListColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');